export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-13.jpg'),
        title: 'ENTERPRISE APPLICATION',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: 'A CRITICAL COMPONENT OF ANY ORGANIZATION',
      description: `<p style="font-size:1.5rem">As your organization grows, you will find that ready-made software does not satisfy your corporate environment's needs anymore. Corporations and big enterprises have their own, unique, business process, data structure and workflow and that is where an Enterprise Application comes in: it is a large software platform designed specifically to cater to a particular organization's needs. An Enterprise application, also known as enterprise application software (EAS), is a critical component of any organization, including (but not limited to) businesses, educational institutions, banks and even governments. An Enterprise Application will enhance an organization's workflow and productivity.MaesInfo's software development services include Enterprise Application development customized to your organization's needs. Our software development team has extensive experience building software applications for clients all over the world. Some of the Enterprise Applications that we have developed include (but are not limited to):</p>
      <p>payment processing systems
*automated billing systems
*CRM (customer relationship management)
*ERP (enterprise resource planning) http://maesinfo.com/solutions/erp.html
*BCP (business continuity planning)
*RFID (radio frequency identification) http://maesinfo.com/solutions/rfid.html
*IT service management and many others
</p>`
    },
    {
      title: 'BENEFITS OF PARTNERING WITH MAESINFO:',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-13.jpg')+`)"></span>
      <span class="list">
      <i></i>Our team of consultants can offer advise to application technology and service
providers on where and how to grow their businesses in the rapidly changing
global market<br/>
 <i></i>Helping your enterprise application migrate your entire infrastructure to the
cloud, as more and more businesses switch to offering On-Demand type of
services<br/>
 <i></i>Our team is able to build you a scalable enterprise application, making it as
complex as you need it<br/>
 <i></i>MaesInfo will integrate all your organizations' business processes (such as
accounting, sales, HR, and manufacturing) into an Enterprise application, thus
giving you control  over all of them through a single software architecture<br/>
 <i></i>We can integrate suppliers, customers, partners into your enterprise application<br/>
 <i></i>We offer not only a cost-efficient solution, but also time efficient one<br/>
 <i></i>We can deploy your Enterprise Application across a variety of networks (Internet,
Intranet and corporate networks) with appropriate security measures
      </span>`
    }
  ]
}
